import type { ViewComponentInstance } from '../../types/view-config.types';

/** Shared runtime-only chrome. Never persists derived instances into app data. */
export function normalizeKnowledgeBaseChrome(
  components: readonly ViewComponentInstance[]
): ViewComponentInstance[] {
  if (
    !components.some(
      component =>
        component.componentType === 'knowledge-base-gallery' ||
        component.componentType === 'single-article'
    )
  )
    return [...components];

  const navigation = components.filter(
    component => component.componentType === 'custom-app-navigation'
  );
  const breadcrumbPosition = {
    x: 0,
    y:
      Math.max(
        navigation.length - 1,
        ...components
          .filter(
            component =>
              component.slotKey === 'header' &&
              component.componentType !== 'custom-app-navigation' &&
              component.componentType !== 'breadcrumb'
          )
          .map(component => component.position.y)
      ) + 1,
    w: 12,
    h: 1,
  };
  const result = components.map(component => {
    if (component.componentType === 'custom-app-navigation') {
      return {
        ...component,
        id: `kb-runtime-navigation-${navigation.indexOf(component)}`,
        slotKey: 'header' as const,
        position: { x: 0, y: navigation.indexOf(component), w: 12, h: 1 },
        props: { ...component.props, orientation: 'header' },
      };
    }
    if (component.componentType === 'breadcrumb') {
      return {
        ...component,
        id: 'kb-runtime-breadcrumb',
        slotKey: 'header' as const,
        position: breadcrumbPosition,
      };
    }
    return component;
  });
  if (!result.some(component => component.componentType === 'breadcrumb')) {
    result.push({
      id: 'kb-runtime-breadcrumb',
      componentType: 'breadcrumb',
      slotKey: 'header',
      position: breadcrumbPosition,
      props: {},
    });
  }
  // Breadcrumb is always the last header item, independent of page geometry.
  return [
    ...result.filter(component => component.componentType !== 'breadcrumb'),
    ...result
      .filter(component => component.componentType === 'breadcrumb')
      .slice(0, 1),
  ];
}
